import React from 'react';
import PropTypes from 'prop-types';
import {PulseLoader} from 'halogenium';
import {ThemeContext} from '../';

const Loader = (props) => {
  const {margin, size} = props;

  return (
    <ThemeContext.Consumer>
      {theme => (
        <PulseLoader color={theme.primaryColor} size={size} margin={margin} key={0} className="pulse-loader text-center"/>
      )}
    </ThemeContext.Consumer>
  );
};

Loader.propTypes = {
  size: PropTypes.string,
  margin: PropTypes.string,
};

Loader.defaultProps = {
  size: '16px',
  margin: '10px',
};

export default Loader;
